module.exports = __webpack_public_path__ + "img/client4.bf83c72e.png";